module.exports = __webpack_public_path__ + "static/media/dark-theme-adblue-fault.870e1887.svg";